import React, { FunctionComponent } from "react";
import { ButtonProps } from "./ButtonShared";

const ButtonFlatPrimary = React.forwardRef(
    (
        {
            Base,
            className,
            ...props
        }: {
            Base: FunctionComponent<
                ButtonProps & {
                    buttonClassName?: string;
                    textClassName?: string;
                    iconClassName?: string;
                } & React.ButtonHTMLAttributes<HTMLButtonElement>
            >;
        } & ButtonProps &
            React.ButtonHTMLAttributes<HTMLButtonElement> &
            React.RefAttributes<HTMLButtonElement>,
        forwardedRef: React.Ref<HTMLButtonElement>
    ) => {
        return (
            <Base
                ref={forwardedRef}
                className={`bg-green hover:bg-green-300 active:bg-green-650 border border-brand_secondary disabled:border-none ${className}`}
                textClassName="text-white"
                iconClassName="text-white"
                {...props}
            />
        );
    }
);

export default ButtonFlatPrimary;
